if (!customElements.get("product-sticky-bar")) {
  class ProductStickyBar extends HTMLElement {
    constructor() {
      super();
      this.stickyBar = this;
      this.addToCartBtn = this.querySelector("#add-to-cart-btn");
      this.cartToast = document.getElementById("cart-toast");

      const variantsScript = this.querySelector("[data-product-variants]");
      this.variants = variantsScript
        ? JSON.parse(variantsScript.textContent)
        : [];

      this.addToCart = this.addToCart.bind(this);
    }

    connectedCallback() {
      // Active size option handler
      const sizeOptions = this.querySelectorAll(
        ".size-option:not(.is-disabled)",
      );
      sizeOptions.forEach((option) => {
        option.addEventListener("click", (e) => {
          const container = e.target.closest(".product-bar__sizes");
          if (container) {
            container
              .querySelectorAll(".size-option")
              .forEach((opt) => opt.classList.remove("active"));
            e.target.classList.add("active");
          }
        });
      });

      // Intersection Observer for .pdp-container
      this.pdpContainer = document.querySelector(".pdp-container");
      if (this.pdpContainer) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (
                !entry.isIntersecting &&
                entry.boundingClientRect.bottom <= 0
              ) {
                this.stickyBar.classList.add("is-sticky");
              } else {
                this.stickyBar.classList.remove("is-sticky");
              }
            });
          },
          {
            root: null,
            rootMargin: "0px",
            threshold: 0,
          },
        );

        this.observer.observe(this.pdpContainer);
      }

      // Add to Cart handler
      if (this.addToCartBtn) {
        this.addToCartBtn.addEventListener("click", this.addToCart);
      }
    }

    disconnectedCallback() {
      if (this.observer && this.pdpContainer) {
        this.observer.unobserve(this.pdpContainer);
        this.observer.disconnect();
      }
      if (this.addToCartBtn) {
        this.addToCartBtn.removeEventListener("click", this.addToCart);
      }
    }

    getCurrentVariantId() {
      if (this.variants.length === 0) return null;

      // Collect selected options
      const selectedOptions = {};
      const optionSelectors = this.querySelectorAll(".option-selector");

      optionSelectors.forEach((selector) => {
        const optionPosition = selector.getAttribute("data-option-position");
        if (!optionPosition) return;

        if (selector.tagName === "SELECT") {
          selectedOptions[optionPosition] = selector.value;
        } else if (
          selector.classList.contains("size-option") &&
          selector.classList.contains("active")
        ) {
          selectedOptions[optionPosition] = selector.getAttribute("data-value");
        }
      });

      // Find variant matching all selected options
      const variant = this.variants.find((v) => {
        return Object.keys(selectedOptions).every(
          (key) => v[key] === selectedOptions[key],
        );
      });

      return variant ? variant.id : null;
    }

    addToCart() {
      const variantId = this.getCurrentVariantId();
      if (!variantId) {
        if (this.cartToast && typeof this.cartToast.show === "function") {
          this.cartToast.show(
            "Error: Please select all options",
            this.stickyBar,
          );
        }
        return;
      }

      this.setLoading(this.addToCartBtn, true);

      const formData = {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
        sections: "cart-drawer,mejimeji-header",
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          // if (this.cartToast && typeof this.cartToast.show === "function") {
          //   this.cartToast.show("Added to cart", this.stickyBar);
          // } else {
          //   console.log("Added to cart:", data);
          // }
          // Update cart drawer using existing global functions
          if (window.updateCartDrawer) {
            window.updateCartDrawer();
          }

          if (window.openCart) {
            window.openCart();
          }

          // If cart-drawer.js updateCartCount is available, we can use it with returned sections
          if (
            window.updateCartCount &&
            data.sections &&
            data.sections["mejimeji-header"]
          ) {
            window.updateCartCount(data.sections["mejimeji-header"]);
          }
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);
          if (this.cartToast && typeof this.cartToast.show === "function") {
            this.cartToast.show("Error adding to cart", this.stickyBar);
          }
        })
        .finally(() => {
          this.setLoading(this.addToCartBtn, false);
        });
    }

    setLoading(button, isLoading) {
      if (isLoading) {
        button.classList.add("loading");
        button.disabled = true;
      } else {
        button.classList.remove("loading");
        button.disabled = false;
      }
    }
  }

  customElements.define("product-sticky-bar", ProductStickyBar);
}
